module.exports = __webpack_public_path__ + "static/media/temp_46.b6dbda8a.jpg";